import { defineStore } from 'pinia';

export default defineStore('snackbar Store', {
  state: () => ({
    text: '',
    timeout: -1,
    color: 'green',
    control: false,
  }),
  actions: {
    // 顯示提示訊息，傳入 { text, color, timeout }
    snackbarMessage(data) {
      this.text = data.text;
      this.color = data.color || 'green';

      const noTimeout = !data.timeout || parseInt(data.timeout) <= 0;
      this.timeout = noTimeout ? 3000 : data.timeout;

      this.control = true;
    },
    // 顯示 API 錯誤，訊息以後端的 detail 為主
    snackbarError(error) {
      let text = '發生未預期的錯誤，請稍後再試';

      if (!error.response) {
        text = '無法連線到伺服器';
      } else if (error.response.data?.detail) {
        text = error.response.data.detail;
      }

      this.snackbarMessage({ text, color: 'error' });
    },
  },
});